/**
 * @file MorphBg.
 */

import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

/**
 * Morph Background.
 */
const morphBg = () => {
	const morphs = document.querySelectorAll('.v-morph-bg');
	if (!morphs.length) {
		return;
	}

	gsap.registerPlugin(ScrollTrigger);

	const bgTops           = document.querySelectorAll('.v-morph-bg__top');
	const header           = document.querySelector('.v-header');
	const colorMorphs      = [...morphs].filter((m) => m.dataset.morphBg === '1');
	const heightMorphs     = [...morphs].filter((m) => m.dataset.morphHeight === '1');
	const translateLMorphs = [...morphs].filter((m) => m.dataset.morphTranslate === 'large');
	const translateSMorphs = [...morphs].filter((m) => m.dataset.morphTranslate === 'small');

	ScrollTrigger.saveStyles([
		...translateLMorphs,
		...translateSMorphs,
		...colorMorphs,
		...heightMorphs,
		...bgTops,
	]);

	ScrollTrigger.matchMedia({
		'(min-width: 1025px)': () => {
			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: header,
					start:   'bottom top',
					end:     '+=300px',
					scrub:   true,
				},
				defaults: { duration: 1 },
			});
			if (translateLMorphs.length) {
				tl.fromTo(translateLMorphs, { translateY: 0 }, {
					translateY: '35%',
				});
			}
			if (translateSMorphs.length) {
				tl.fromTo(translateSMorphs, { translateY: 0 }, {
					translateY: '9vw',
				}, '<');
			}
			if (colorMorphs.length) {
				tl.fromTo(colorMorphs, { color: '#f7f7f7' }, {
					color: '#fff',
				}, '<');
			}
			if (heightMorphs.length) {
				tl.to(heightMorphs, {
					height: 605,
				}, '<');
			}
			if (bgTops.length) {
				tl.fromTo(bgTops, { scaleY: 0 }, {
					scaleY: 1,
				}, '<');
			}
		},
		'(min-width: 551px) and (max-width: 1024px)': () => {
			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: header,
					start:   'bottom top',
					end:     '+=300px',
					scrub:   true,
				},
				defaults: { duration: 1 },
			});
			if (translateLMorphs.length) {
				tl.fromTo(translateLMorphs, { translateY: 0 }, {
					translateY: '55%',
				});
			}
			if (translateSMorphs.length) {
				tl.fromTo(translateSMorphs, { translateY: 0 }, {
					translateY: '9vw',
				}, '<');
			}
			if (colorMorphs.length) {
				tl.fromTo(colorMorphs, { color: '#f7f7f7' }, {
					color: '#fff',
				}, '<');
			}
			if (heightMorphs.length) {
				tl.to(heightMorphs, {
					height: 455,
				}, '<');
			}
			if (bgTops.length) {
				tl.fromTo(bgTops, { scaleY: 0 }, {
					scaleY: 1,
				}, '<');
			}
		},
		'(max-width: 550px)': () => {
			const tl = gsap.timeline({
				scrollTrigger: {
					trigger: 'body',
					start:   '20px top',
					end:     '+=300px',
					scrub:   true,
				},
				defaults: { duration: 1 },
			});
			if (bgTops.length) {
				tl.fromTo(bgTops, { scaleY: 0 }, {
					scaleY: 1,
				}, '<');
			}
		},
	});
};

export default morphBg;
